"use client"

import { ComponentConfig } from "@measured/puck"
import SupplierGridContent from "./components/SupplierGridContent"
import type { SupplierGridProps } from "./types"

export const RenderConfig: ComponentConfig<SupplierGridProps> = {
  render: ({ items, className }) => {
    return <SupplierGridContent items={items ?? []} className={className} />
  },
}
